module.exports = __webpack_public_path__ + "static/media/ajax-Loader.ce2e78bc.gif";